// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--cs6wc","heading":"footer-module--heading--1XQRp","link":"footer-module--link--ylud_"};